import type { JSX } from 'react';
import { Badge } from '@/components/ui/badge';
import type { JobPositionStatus } from '../types/jobPosition.types';
import { cn } from '@/lib/utils';

interface JobPositionStatusBadgeProps {
  status: JobPositionStatus;
  className?: string | undefined;
}

const statusConfig: Record<
  JobPositionStatus,
  {
    variant: 'default' | 'destructive' | 'secondary' | 'outline';
    label: string;
    customClass?: string;
  }
> = {
  UPCOMING: {
    variant: 'outline',
    label: 'Upcoming',
    customClass: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  },
  OPEN: {
    variant: 'default',
    label: 'Open',
    customClass: 'bg-green-100 text-green-800 border-green-300',
  },
  CLOSED: { variant: 'secondary', label: 'Closed' },
  ARCHIVED: {
    variant: 'outline',
    label: 'Archived',
    customClass: 'bg-pink-100 text-pink-800 border-pink-300',
  },
};

export function JobPositionStatusBadge({
  status,
  className,
}: JobPositionStatusBadgeProps): JSX.Element {
  const { variant, label, customClass } = statusConfig[status];
  return (
    <Badge variant={variant} className={cn(customClass, className)}>
      {label}
    </Badge>
  );
}
